// extracted by mini-css-extract-plugin
module.exports = {"popularSearches":"styles_popularSearches__wBCvd","title":"styles_title__URhcy","grid":"styles_grid__w1f6K","cell":"styles_cell__06n8d","query":"styles_query__uI_b0"};